export const member = {
  list: '会员列表',
  from: '会员操作',
  info: '会员信息',
  view: '会员详情',
  delete: '删除会员',

  mini_code: '小程序码',
  mini_placard: '短海报',
  placard: '长海报',

  inviter: '邀请人',
  avatar: '会员头像',
  username: '登录账户',
  email: '登录邮箱',
  chinese_nickname: '中文姓名',
  english_nickname: '英文姓名',
  chinese_mobile: '中文手机号码',
  english_mobile: '英文手机号码',
  market_status: '销售状态',
  verify_status: '认证状态',
  failure_status: '失效状态',
  status: '账号状态',
  role_title: '会员身份',
  valid_time: '会员有效期',
  business_card: '个人名片',
  organization_info: '公司信息',
  last_login_time: '最后登录时间',
  valid_time: '剩余有效时间',
  create_time: '注册时间',

  rules: {
    username_or_email: {
      require: '登录账户和登录邮箱必须填写一个',
    },
    chinese_nickname: {
      require: '中文姓名不能为空',
    },
    english_nickname: {
      require: '英文姓名不能为空',
    },
  },

  certification: {
    info: '会员认证',
  },

  invoice: {
    list: '发票列表',
    from: '发票审核',

    nickname: '会员信息',
    category: '抬头类型',
    type: '发票类型',
    name: '发票抬头',
    code: '统一社会信用代码',
    email: '用户邮箱',
    mobile: '用户电话',
    audit_status: '审核状态',

    rules: {
      audit_status: {
        require: '审核状态不能为空',
      }
    },
  },

  distribution: {
    list: '分销列表',
    from: '分销审核',
    info: '会员分销',

    nickname: '会员信息',
    money: '分销金额',
    audit_status: '审核状态',

    rules: {
      audit_status: {
        require: '审核状态不能为空',
      }
    },
  },

  invite: {
    list: '邀请列表',
    info: '会员邀请',

    nickname: '会员信息',
  },

  order: {
    list: '订单列表',
    view: '订单详情',

    order_no: '订单号',
    order_type: '订单类型',
    member_info: '会员信息',
    order_info: '订单信息',
    contact_info: '联系信息',
    country_name: '所属国家',
    money: '订单金额',
    pay_money: '支付金额',
    pay_type: '支付方式',
    pay_status: '支付状态',
    order_status: '订单状态',
    is_activity: '活动订单',
    pay_time: '支付时间',
    create_time: '创建时间',

    contact: {
      email: '电子邮箱',
      name: '姓名',
      company_name: '公司名称',
      phone: '电话',
      address: '地址',
      remark: '备注',
    }
  },


  duration: {
    info: '时长日志',

    member_info: '会员信息',

    source: '时长来源',
    type: '周期类型',
    value: '会员时长',
    create_time: '获取时间',
  },

  company: {
    info: '企业认证',

    chinese_company_name: '中文企业名称',
    english_company_name: '英文企业名称',
  },

  behavior: {
    list: '行为列表',
    base_info: '数据统计',
    export: '导出会员行为',
    export_activity_harobr: '导出活跃港口',

    normal_schedule_total: '件杂货船期查询',
    normal_schedule_detail_total: '件杂货详情查看',
    container_schedule_total: '集装箱船期查询',
    inquiry_publish_total: '询价订单发布',
    ship_search_total: '船舶查询',
    article_browse_total: '资讯浏览',
    global_serach_total: '全局搜索',
    invitation_total: '会员邀请',
    share_total: '会员分享',
    contact_total: '拨打电话',
    email_total: '复制邮箱',
    shipowner_total: '船东详情查询',
    create_time: '最新操作时间',
    than_yesterday: '比昨天',
    is_transporter: '运力公司',

    recommend_total: '首页推荐',
    top_1_total: '置顶位置一',
    top_2_total: '置顶位置二',
    top_3_total: '置顶位置三',

    normal: {
      info: '普货查询行为',

      shipowner_info: '船东信息',
      category_id: '航运分类',
      machine_id: '船只类型',
      start_harbor_info: '起始港信息',
      start_harbor_code: '起始港',
      end_harbor_info: '目的港信息',
      end_harbor_code: '目的港',
      schedule: '船期',
      create_time: '操作时间',

      detail: {
        info: '船期详情查看行为',

        information_info: '船期信息',
        total: '查看次数',
        create_time: '查看时间',
      },
    },
    container: {
      info: '集装箱查询行为',

      start_harbor_info: '起始港信息',
      start_harbor_code: '起始港',
      end_harbor_info: '目的港信息',
      end_harbor_code: '目的港',
      search_time: '离港日期',
      create_time: '操作时间',
    },
    inquiry: {
      info: '询价发布行为',

      create_time: '操作时间',
    },
    ship: {
      info: '船只查询行为',

      ship_name: '船名',
      create_time: '操作时间',
    },
    article: {
      info: '资讯浏览行为',

      title: '资讯标题',
      create_time: '操作时间',
    },

    contact: {
      info: '拨打电话行为',

      shipowner_info: '船东信息',
      manager_info: '联系人信息',
      mobile: '联系电话',
      total: '拨打次数',
      create_time: '拨打时间',
    },

    email: {
      info: '复制邮箱行为',

      shipowner_info: '船东信息',
      manager_info: '联系人信息',
      email: '联系邮箱',
      total: '复制次数',
      create_time: '复制时间',
    },

    shipowner: {
      info: '船东详情行为',

      shipowner_info: '船东信息',
      create_time: '查看时间',
    },

    advertising: {
      info: '广告点击行为',

      position_statistics: '广告位统计',
      once_statistics: '单次点击统计',

      organization_info: '公司信息',
      total: '点击总数',
      wechat_total: '小程序点击次数',
      web_total: '网站点击次数',
      visit_total: '每日访问数',
      check_rate: '点击率',
      source: '访问来源',
      stat_date: '统计日期',
      create_time: '点击时间',
    },
  },

  contract: {
    from: '会员合约',
    info: '合约信息',

    contract_name: '合约名称',
    valid_time: '合约有效期',
  },

  refuel: {
    from: '会员加油包',
    info: '加油包信息',

    schedule_refuel_total: '船期查询剩余次数',
    inquiry_refuel_total: '询价发布剩余次数',
  },

  market: {
    info: '销售信息',

    first_level_rate: '一级分销比例',
    second_level_rate: '二级分销比例',
    market_status: '销售状态',
  },

  setting: {
    exchange_total: '兑换次数'
  },

  apply: {
    list: '申请列表',
    from: '申请审核',
    info: '申请信息',

    remark: '申请备注',
    create_time: '申请时间',
    apply_status: '申请状态',

    rules: {
      apply_status: {
        require: '申请状态不能为空',
      }
    },
  },

  publish: {
    record: {
      unused_publish_total: '剩余发布次数',
      used_publish_total: '本次使用发布次数',
      unused_refuel_total: '剩余加油包次数',
      used_refuel_total: '本次使用加油包次数',
    }
  },
}
